// INVOICE SYMBOL LIST
export const INVOICE_SYMBOL_LIST = "INVOICE_SYMBOL_LIST";
export const INVOICE_SYMBOL_LIST_SUCCESS = "INVOICE_SYMBOL_LIST_SUCCESS";
export const INVOICE_SYMBOL_LIST_FAIL = "INVOICE_SYMBOL_LIST_FAIL";
export const INVOICE_SYMBOL_LIST_RESET = "INVOICE_SYMBOL_LIST_RESET";
export const INVOICE_SYMBOL_LIST_COLUMN = "INVOICE_SYMBOL_LIST_COLUMN";

// INVOICE SYMBOL DETAIL
export const INVOICE_SYMBOL_DETAIL = "INVOICE_SYMBOL_DETAIL";
export const INVOICE_SYMBOL_DETAIL_SUCCESS = "INVOICE_SYMBOL_DETAIL_SUCCESS";
export const INVOICE_SYMBOL_DETAIL_FAIL = "INVOICE_SYMBOL_DETAIL_FAIL";
export const INVOICE_SYMBOL_DETAIL_RESET = "INVOICE_SYMBOL_DETAIL_RESET";

// INVOICE SYMBOL CREATE
export const INVOICE_SYMBOL_CREATE = "INVOICE_SYMBOL_CREATE";
export const INVOICE_SYMBOL_CREATE_SUCCESS = "INVOICE_SYMBOL_CREATE_SUCCESS";
export const INVOICE_SYMBOL_CREATE_FAIL = "INVOICE_SYMBOL_CREATE_FAIL";
export const INVOICE_SYMBOL_CREATE_RESET = "INVOICE_SYMBOL_CREATE_RESET";

// INVOICE SYMBOL UPDATE
export const INVOICE_SYMBOL_UPDATE = "INVOICE_SYMBOL_UPDATE";
export const INVOICE_SYMBOL_UPDATE_SUCCESS = "INVOICE_SYMBOL_UPDATE_SUCCESS";
export const INVOICE_SYMBOL_UPDATE_FAIL = "INVOICE_SYMBOL_UPDATE_FAIL";
export const INVOICE_SYMBOL_UPDATE_RESET = "INVOICE_SYMBOL_UPDATE_RESET";

// INVOICE SYMBOL DELETE
export const INVOICE_SYMBOL_DELETE = "INVOICE_SYMBOL_DELETE";
export const INVOICE_SYMBOL_DELETE_SUCCESS = "INVOICE_SYMBOL_DELETE_SUCCESS";
export const INVOICE_SYMBOL_DELETE_FAIL = "INVOICE_SYMBOL_DELETE_FAIL";
export const INVOICE_SYMBOL_DELETE_RESET = "INVOICE_SYMBOL_DELETE_RESET";

// INVOICE SYMBOL ACTIVE
export const INVOICE_SYMBOL_ACTIVE = "INVOICE_SYMBOL_ACTIVE";
export const INVOICE_SYMBOL_ACTIVE_SUCCESS = "INVOICE_SYMBOL_ACTIVE_SUCCESS";
export const INVOICE_SYMBOL_ACTIVE_FAIL = "INVOICE_SYMBOL_ACTIVE_FAIL";
export const INVOICE_SYMBOL_ACTIVE_RESET = "INVOICE_SYMBOL_ACTIVE_RESET";